import { useNavbar } from '@/layout/components/share'
import { inject } from 'vue'

export const msgNavbar = (state, appendMsg) => {
  const socketRequest = (url, callback) => {
    let ws = null
    const reconnectInterval = 3000 //重连间隔

    const connect = () => {
      const socketUrl = process.env.VUE_APP_WS_PROTAL + url
      ws = new WebSocket(socketUrl)
      ws.onopen = () => {
        console.log('WebSocket 连接成功')
      }

      ws.onmessage = event => {
        if (callback) {
          callback(event.data)
        }
      }

      ws.onclose = event => {
        if (event.code === 1000) {
          console.log('WebSocket 连接正常关闭')
        } else {
          console.log('WebSocket 连接异常断开，尝试重连...', event)
          //尝试重连
          reconnect()
        }
      }
    }

    const closeConnect = () => {
      if (ws) {
        ws.close()
      }
    }

    // ws重连
    const reconnect = () => {
      setTimeout(() => {
        connect()
      }, reconnectInterval)
    }

    return {
      connect,
      reconnect,
      closeConnect
    }
  }

  const socketReq = socketRequest(
    `/portal/websocket/message?Authorization=${localStorage.getItem('token') ||
      null}`,
    data => {
      handleMsg(data)
    }
  )

  const connect = () => {
    socketReq.connect()
  }

  const closeConnect = () => {
    socketReq.closeConnect()
  }

  const handleMsg = data => {
    console.log('接收到服务端消息：', data)

    let jsonData
    try {
      jsonData = JSON.parse(data)
    } catch (error) {
      console.error('JSON解析失败:', error)
      return
    }

    // 调用 Message.vue 中的 appendMsg 方法
    if (appendMsg && typeof appendMsg === 'function') {
      appendMsg(jsonData)
    }
  }

  return {
    connect,
    closeConnect
  }
}
